import { KeyValuePair } from '../../hooks/http/types';
import useFetchOnLoad from '../../hooks/http/useFetchOnLoad';
import If from '../common/If';
import LoadingSpinner from './LoadingSpinner';
import ErrorBanner from '../common/banners/ErrorBanner';
import settings from '../../config';
import { ErrorWithStatusCodeProps } from './types';

type ApiActionWithChildrenProps<T> = React.PropsWithChildren & {
    apiEndpoint: string;
    customErrorComponent?: ({ statusCode }: ErrorWithStatusCodeProps) => JSX.Element;
    nonNcassEndpoint?: boolean;
    onDataFetched: (data: T) => void;
    queryParameters?: KeyValuePair<string>[];
};

export const ApiActionWithChildren = <T,>({
    apiEndpoint,
    children,
    customErrorComponent,
    nonNcassEndpoint,
    onDataFetched,
    queryParameters,
}: ApiActionWithChildrenProps<T>) => {
    const url = nonNcassEndpoint ? apiEndpoint : `${settings.API_URL}${apiEndpoint}`;

    const { error, fetchStatus } = useFetchOnLoad<T>({
        url,
        onComplete: onDataFetched,
        queryParameters,
        nonNcassEndpoint
    });

    return (
        <>
            <If _this={!!error}>
                <If _this={!customErrorComponent}>
                    <ErrorBanner boldText='API ERROR' text={`Unable to load the resource at ${apiEndpoint}`} />
                </If>
                {
                    customErrorComponent && customErrorComponent({statusCode: error?.statusCode})
                }
            </If>
            <If _this={fetchStatus === 'Fetching'}>
                <LoadingSpinner />
            </If>
            <If _this={fetchStatus === 'Done' && !error}>{children}</If>
        </>
    );
};

export default ApiActionWithChildren;

